export default "__VITE_ASSET__DmNQWEUk__"